import React, { useEffect, useState } from "react";
import { Table, Button, Alert } from "react-bootstrap";
import PaginationButtons from "../../../../reuseable-components/PaginationButtons"; // Assuming you have a reusable pagination component
import axios from "axios";
import swal from "sweetalert";
import getServerURL from "../../../../functions/getServerURL"; // Import getServerURL
import { handleErrorFetchingData } from "../../../../functions/errorHandling";

export default function DeactivatedFunctionalGroups() {
  const [deactivatedGroups, setDeactivatedGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [numberOfPages, setNumberOfPages] = useState(0); // Total pages
  const entriesPerPage = 10; // Number of items per page

  // Fetch deactivated functional groups with pagination
  const fetchDeactivatedGroups = (page = currentPage) => {
    setLoading(true);
    page = page || 1;
    setCurrentPage(page);
    axios
      .get(`${getServerURL()}functional-groups`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: {
          is_active: false,
          limit: entriesPerPage,
          offset: entriesPerPage * (page - 1),
        },
      })
      .then((response) => {
        setDeactivatedGroups(response.data.results || []); // Extract `results` field
        setNumberOfPages(Math.ceil(response.data.count / entriesPerPage)); // Calculate total pages
      })
      .catch((error) => {
        setErrorMessage("Failed to fetch deactivated functional groups.");
        handleErrorFetchingData(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Activate a functional group
  const handleActivateGroup = (group) => {
    swal({
      text: `Activating ${group.name}... Please stand by.`,
      icon: require("../../../../static/images/spinner.gif"),
      button: false,
    });
    axios
      .patch(group.url, { is_active: true }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(() => {
        swal({
          title: "Activated",
          text: `${group.name} has been successfully activated.`,
          icon: "success",
          button: "OK",
        }).then(() => {
          fetchDeactivatedGroups(currentPage); // Refresh the current page
        });
      })
      .catch((error) => {
        const message = `There was an error activating the functional group: ${group.name}`;
        handleErrorFetchingData(error, message);
      });
  };

  useEffect(() => {
    fetchDeactivatedGroups();
  }, []);

  return (
    <div>
      <h3>Deactivated Functional Groups</h3>
      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
      {numberOfPages > 1 && (
        <center>
          <PaginationButtons
            onClick={fetchDeactivatedGroups}
            numberOfPages={numberOfPages}
            currentPage={currentPage}
            buttonsPerPage={5}
            disabled={loading}
          />
        </center>
      )}
      {loading ? (
        <p>Loading...</p>
      ) : deactivatedGroups.length === 0 ? (
        <p>No deactivated functional groups found.</p>
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {deactivatedGroups.map((group) => (
              <tr key={group.id}>
                <td>{group.name}</td>
                <td>
                  <Button
                    variant="success"
                    onClick={() => handleActivateGroup(group)}
                  >
                    Activate
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/DeactivatedFunctionalGroups.js